<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="180px" v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="userName" label="客户名称">
              {{ formData.userName || "" }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="总保证金">
              {{ formData.depositAllChange || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="未锁定保证金">
              {{ calcUnlockedDeposit() }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="已锁定保证金">
              {{ calcLockedDeposit() }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="充值保证金">
              {{ formData.depositChange || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="未锁定充值保证金">
              {{ formData.depositAfterChange || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="已锁定充值总证金">
              {{ calcLockedDepositChange() }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="收益金">
              {{ formData.pickupChange || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="未锁定收益金">
              {{ formData.pickupAfterChange }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="已锁定收益金">
              {{ calcLockedPickupChange() }}
            </el-form-item>
          </el-col>
<!--          <el-col :span="6">-->
<!--            <el-form-item label="金融保证金">-->
<!--              {{ formData.jrChange || "" }}-->
<!--            </el-form-item>-->
<!--          </el-col>-->
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item prop="goodsChange" label="货款总额">
              {{ formData.goodsChange || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="goodsAfterChange" label="未锁定货款">
              {{ formData.goodsAfterChange || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="" label="已锁定货款">
              {{ calcLockedGoodsChange() }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item prop="goodsAfterChange" label="金融待还金额">
              {{ formData.financeLoanBalance || "" }}
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <div class="title-box">保证金流水记录</div> -->
        <el-row>
          <el-col :span="24">

            <el-form-item prop="" label="保证金流水记录">
              <div class="btn-between">
                <el-button type="primary" v-if="hasEdit" @click="onDownExcel('1')">导出</el-button>
                <!-- <el-button type="primary" v-if="hasEdit2" @click="onChangeBzj">调整收益金</el-button> -->
              </div>
              <el-table size="mini" stripe border style="margin-top:14px;" :data="tableData">
                <el-table-column show-overflow-tooltip min-width="120" label="流水编号"
                  prop="transactionId"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120" label="关联单号" prop="oderNumber"></el-table-column>
                <el-table-column min-width="120" label="变动保证金" prop="amountChange"></el-table-column>
                <el-table-column min-width="120" label="变动原因" prop="changeReason"></el-table-column>
                <el-table-column min-width="120" label="金额类型" prop="transactionType">
                  <template v-slot="{ row }">
                    <span v-if="row.transactionType === '2'">收益金</span>
                    <span v-else>{{ transactionTypeMap.get(row.transactionType) || '--' }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="160" label="变动方式" prop="">
                  <template v-slot="{ row }">
                    <span :class="{ 'text-success': row.amountType == '3', 'text-danger': row.amountType == '4' }">{{
                      amountTypeMap.get(row.amountType) || '--' }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="160" label="变动后余额" prop="">
                  <template v-slot="{ row }">
                    {{ ['1', '2'].includes(row.amountType) ? row.balanceAfterChange : row.balanceAllChange }}
                  </template>
                </el-table-column>
                <!-- <el-table-column min-width="120" label="变动类型" prop="changeType">
                  <template v-slot="{ row }">
                    {{ changeTypeMap.get(row.changeType) || '--' }}
                  </template>
</el-table-column> -->
              </el-table>

              <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next"
                :total="total" @current-change="loadTableData">
              </el-pagination>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="" label="货款流水记录">
              <el-button type="primary" v-if="hasEdit" @click="onDownExcel('2')">导出</el-button>

              <el-table size="mini" stripe border style="margin-top:14px;" :data="tableData2">
                <el-table-column show-overflow-tooltip min-width="120" label="流水编号"
                  prop="transactionId"></el-table-column>
                <el-table-column width="230" label="关联单号" prop="oderNumber">
                  <template v-slot="{ row }">
                    <el-button type="text" @click="toDetail(row.oderNumber)">{{ row.oderNumber }}</el-button>
                    <el-button type="text" @click.stop="handleCopyText(row.oderNumber)">复制</el-button>
                  </template>
                </el-table-column>
                <el-table-column min-width="120" label="变动货款" prop="amountChange"></el-table-column>
                <el-table-column min-width="120" label="变动原因" prop="changeReason"></el-table-column>
                <el-table-column min-width="160" label="变动方式" prop="">
                  <template v-slot="{ row }">
                    <span :class="{ 'text-success': row.amountType == '3', 'text-danger': row.amountType == '4' }">{{
                      amountTypeMap.get(row.amountType) || '--' }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="160" label="变动后余额" prop="">
                  <template v-slot="{ row }">
                    {{ ['1', '2'].includes(row.amountType) ? row.balanceAfterChange : row.balanceAllChange }}
                  </template>
                </el-table-column>
              </el-table>

              <el-pagination class="mt15" :current-page.sync="page2" background layout="total, prev, pager, next"
                :total="total2" @current-change="loadTableData2">
              </el-pagination>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
    <ChangeBzjDlg v-if="showDlg" :showDlg.sync="showDlg" @successSave="successSave" :userId="formData.userId">
    </ChangeBzjDlg>
  </div>
</template>

<script>
import BigNumber from 'bignumber.js'
import ChangeBzjDlg from './ChangeBzjDlg.vue'
import { changeType, amountType, transactionType } from '@/utils/dict'
import { copyText } from '@/utils/utils'
export default {
  name: 'UserBondDetail',
  components: { ChangeBzjDlg },
  data() {
    return {
      showDlg: false,
      changeTypeMap: changeType,
      amountTypeMap: amountType,
      transactionTypeMap: transactionType,
      typeArr: [],
      formData: {
        userId: '',
        userName: '',
        goodsChange: '',
        goodsAfterChange: '',
        unlockedDepositChange: '',
        lockedDepositChange: '',
        depositAllChange: '',
        unlockedJrChange: '',
        lockedJrChange: '',
        jrAllChange: '',
        unlockedPickupChange: '',
        lockedPickupChange: '',
        pickupAllChange: ''
      },
      loading: false,
      page: 1,
      total: 0,
      tableData: [],
      page2: 1,
      total2: 0,
      tableData2: []
    }
  },
  created() {
    if (this.userId) {
      this.loadData()
      this.loadTableData()
      this.loadTableData2()
    }
  },
  computed: {
    userId() {
      return this.$route.query.userId
    },
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasEdit() {
      return this.buttonList.includes('export')
    },
    hasEdit2() {
      return this.buttonList.includes('edit')
    }
  },
  methods: {
    // 复制文本
    async handleCopyText(text) {
      const success = await copyText(text)
      if (success) {
        this.$message.success('复制成功')
      } else {
        this.$message.error('复制失败，请手动复制')
      }
    },
    calcUnlockedDeposit() {
      return new BigNumber(this.formData.pickupAfterChange || 0)
        .plus(this.formData.depositAfterChange || 0)
        .decimalPlaces(3)
        .toString()
    },
    calcLockedDeposit() {
      const unlocked = new BigNumber(this.formData.pickupAfterChange || 0)
        .plus(this.formData.depositAfterChange || 0)
      return new BigNumber(this.formData.depositAllChange || 0)
        .minus(unlocked)
        .decimalPlaces(3)
        .toString()
    },
    calcLockedDepositChange() {
      return new BigNumber(this.formData.depositChange || 0)
        .minus(this.formData.depositAfterChange || 0)
        .decimalPlaces(3)
        .toString()
    },
    calcLockedPickupChange() {
      return new BigNumber(this.formData.pickupChange || 0)
        .minus(this.formData.pickupAfterChange || 0)
        .decimalPlaces(3)
        .toString()
    },
    calcLockedGoodsChange() {
      return new BigNumber(this.formData.goodsChange || 0)
        .minus(this.formData.goodsAfterChange || 0)
        .decimalPlaces(3)
        .toString()
    },
    toDetail(orderNumber) {
      const loading = this.$loading({
        text: '加载中',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this.$axios.get(this.$apis.deliveryOrder.selectYxPickupOrderByPickupNum, {
        pickupNumber: orderNumber
      }).then(res => {
        this.$router.push('/deliveryOrder/detail?pickupId=' + res.pickupId)
      }).finally(() => {
        loading.close()
      })
    },
    successSave() {
      this.loadData()
      this.loadTableData()
      this.loadTableData2()
    },
    onChangeBzj() {
      this.showDlg = true
    },
    onDownExcel(type) {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })

      this.$axios
        .post(
          this.$apis.userBond.exportYxDepositTransaction,
          {
            userId: this.userId,
            transactionType: type
          },
          {
            responseType: 'blob'
          }
        )
        .then(res => {
          if (res) {
            const disposition = res.headers['content-disposition']
            const fileName = disposition
              .substring(disposition.indexOf('filename'))
              .split('=')[1]
            this.downloadFile(res.data, fileName)
          }
        })
        .catch(error => {
          console.error('导出失败:', error)
        })
        .finally(() => {
          loadingInstance.close()
        })
    },
    // onDownExcel2() {
    //   const loadingInstance = this.$loading({
    //     text: '正在导出...',
    //     background: 'rgba(0, 0, 0, 0.8)'
    //   })

    //   this.$axios
    //     .post(
    //       this.$apis.userBond.exportYxDepositGoods,
    //       { userId: this.userId },
    //       {
    //         responseType: 'blob'
    //       }
    //     )
    //     .then(res => {
    //       if (res) {
    //         const disposition = res.headers['content-disposition']
    //         const fileName = disposition
    //           .substring(disposition.indexOf('filename'))
    //           .split('=')[1]
    //         this.downloadFile(res.data, fileName)
    //       }
    //     })
    //     .catch(error => {
    //       console.error('导出失败:', error)
    //     })
    //     .finally(() => {
    //       loadingInstance.close()
    //     })
    // },
    downloadFile(data, fileName) {
      const blob = new Blob([data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      const downloadElement = document.createElement('a')
      // 创建下载的链接
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      // 下载后文件名
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      // 释放掉blob对象
      window.URL.revokeObjectURL(href)
    },
    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.userBond.selectYxUserDepositByDepositId, {
          params: { userId: this.userId }
        })
        .then(res => {
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    loadTableData() {
      this.$axios
        .get(this.$apis.userBond.selectYxTransNewByPage, {
          userId: this.userId,
          page: this.page,
          size: 10,
          transactionType: '1'
        })
        .then(res => {
          this.tableData = res.list || []
          this.total = res.total || 0
        })
    },
    loadTableData2() {
      this.$axios
        .get(this.$apis.userBond.selectYxTransNewByPage, {
          userId: this.userId,
          page: this.page2,
          size: 10,
          transactionType: '2'
        })
        .then(res => {
          this.tableData2 = res.list || []
          this.total2 = res.total || 0
        })
    }
  }
}
</script>

<style>
.text-success {
  color: #1eba1c;
  font-weight: bold;
}

.text-danger {
  color: #f54242;
  font-weight: bold;
}
</style>

<style scoped lang="scss">
.shoufa-form {
  width: 1200px;
}

::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.btn-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title-box {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 14px;
  margin-top: 10px;

  &:before {
    width: 3px;
    height: 14px;
    border-radius: 2px;
    background-color: $color-primary;
    position: absolute;
    top: 50%;
    left: 6px;
    content: "";
    transform: translateY(-50%);
  }
}
</style>
